import { services } from '../services';
var action = "client";

export const clientService = {
    getList,
    getCode
};

function getList(param = '') {
    return services.restStore(`${action}${param}`, 'GET');
}

function getCode(code) {
    return services.restStore(`${action}/${code}`, 'GET');
}